import secureLocalStorage from "react-secure-storage";

import { GET_ALL_CONTACTS_OF_USER } from "helpers/constants";
import {
	findInObjectArrayByMatchingProperties,
	removeItemFromObjectArrayByMatchingProperties,
	replaceItemInObjectArrayByMatchingProperties,
} from "helpers/functions";

import * as api from "middlewares/apis";

import { buildingComponent } from "actions/loaders";
import dexieDB from "database/dexieDB";

export const getAllContactsByUser = () => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// let userContacts = secureLocalStorage.getItem(currentUser?._id + "-Contacts");
			// dispatch({
			// 	type: GET_ALL_CONTACTS_OF_USER,
			// 	payload: userContacts,
			// });
			// const { data } = await api.getAllContactsByUser(currentUser["access-token"]);
			// if (data) secureLocalStorage.setItem("contacts", data);
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.contacts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data?.data) {
						return data.data;
					} else return null;
				});

			dispatch({
				type: GET_ALL_CONTACTS_OF_USER,
				payload: userData,
			});
		}
	} catch (error) {
		console.error(error);
	}
};

export const getContactNameByAccountID = async (accountID) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	if (accountID) {
		try {
			if (currentUser?.loginType === "daffi") {
				// const token = secureLocalStorage.getItem("token");
				// const { data } = await api.updateAccountInfoByID(formData, token);
				// if (data && data["data"]) {
				// 	alert(data["message"]);
				// 	secureLocalStorage.setItem("accounts", data["data"]);
				// } else {
				// 	alert(data["message"]);
				// }
				// dispatch({ type: GET_ALL_ACCOUNTS_OF_USER });
				// dispatch(buildingComponent(false));
			} else if (currentUser?.loginType === "local") {
				const userData = await dexieDB.contacts
					.filter((item) => item?.userID === currentUser?._id)
					.first()
					.then((data) => {
						if (data) {
							return data;
						} else return null;
					});

				if (userData?.data) {
					const matchedContacts = await findInObjectArrayByMatchingProperties(userData?.data, {
						"account-address": accountID,
					});

					if (matchedContacts?.[0]?.["friendly-name"]) return matchedContacts[0]["friendly-name"];
					else return null;
				} else return null;
			}
		} catch (error) {
			console.error(error);
		}
	} else {
		console.log("missing parameter accountID");
	}
};

export const addNewContact = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// let userContacts = secureLocalStorage.getItem(currentUser?._id + "-Contacts");
			// if (userContacts && userContacts.length > 0) {
			// 	const matchedContacts = await findInObjectArrayByMatchingProperties(userContacts, {
			// 		"friendly-name": formData["friendly-name"],
			// 	});
			// 	if (matchedContacts && matchedContacts.length) alert("Contact with same friendly name already exists");
			// 	else {
			// 		userContacts = [...userContacts, formData];
			// 		secureLocalStorage.setItem(currentUser?._id + "-Contacts", userContacts);
			// 		// alert("Contact added in user profile");
			// 	}
			// } else {
			// 	userContacts = [formData];
			// 	secureLocalStorage.setItem(currentUser?._id + "-Contacts", userContacts);
			// 	// alert("Contact added in user profile");
			// }
			// dispatch({
			// 	type: GET_ALL_CONTACTS_OF_USER,
			// 	payload: userContacts,
			// });
			// const { data } = await api.addNewContact(formData, currentUser["access-token"]);
			// if (data && data["message"]) alert(data["message"]);
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.contacts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				const contacts = findInObjectArrayByMatchingProperties(userData.data, {
					"account-address": formData["account-address"],
				});

				if (contacts?.length) {
					notify("error", "Contact with same address already exists");
				} else {
					userData.data.push(formData);

					await dexieDB.contacts.update(userData.id, { data: userData.data }).then((updateCount) => {
						if (updateCount) notify("success", "New contact added");
						else notify("error", "Contact add failed");
					});
				}
			} else {
				await dexieDB.contacts
					.add({
						userID: currentUser?._id,
						data: [formData],
					})
					.then((id) => {
						if (id) notify("success", "New contact added");
						else notify("error", "Contact add failed");
					});
			}

			dispatch({
				type: GET_ALL_CONTACTS_OF_USER,
				payload: userData?.data ? userData.data : [formData],
			});
		}
	} catch (error) {
		console.error(error);
	}
};

export const updateContactInfoByID = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		dispatch(buildingComponent(true));

		if (currentUser?.loginType === "daffi") {
			// const token = secureLocalStorage.getItem("token");
			// const { data } = await api.updateAccountInfoByID(formData, token);
			// if (data && data["data"]) {
			// 	alert(data["message"]);
			// 	secureLocalStorage.setItem("accounts", data["data"]);
			// } else {
			// 	alert(data["message"]);
			// }
			// dispatch({ type: GET_ALL_ACCOUNTS_OF_USER });
			// dispatch(buildingComponent(false));
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.contacts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				const newUserAccounts = replaceItemInObjectArrayByMatchingProperties(
					userData?.data,
					{
						"account-address": formData["account-address"],
					},
					formData
				);

				await dexieDB.contacts.update(userData.id, { data: newUserAccounts }).then((updateCount) => {
					if (!updateCount) notify("error", "Contact info update failed");
					// else notify("success", "Contact info updated");
				});
			} else {
				notify("error", "There are no contact found in user profile");
			}
		}

		dispatch(buildingComponent(false));
	} catch (error) {
		console.error(error);
	}
};

export const updateContactListSortByUserID = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", formData);
			// const { data } = await api.updateAccountListSortByUserID(formData, currentUser["access-token"]);
			// alert("Account sort update::success");
			// if (data && data["message"]) alert(data["message"]);
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.contacts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				await dexieDB.contacts.update(userData.id, { data: formData }).then((updateCount) => {
					if (updateCount) notify("success", "Contact sorting updated");
					else notify("error", "Contact sorting failed");
				});
			} else {
				notify("error", "There are no contacts found in user profile");
			}
		}
	} catch (error) {
		console.error(error);
	}
};

export const deleteContactById = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	try {
		if (currentUser?.loginType === "daffi") {
			// await api.deleteAccountFromUserProfile(formData, currentUser["access-token"]).then(async ({ data }) => {
			// 	if (data && data["error"]) {
			// 		alert(data["message"]);
			// 	} else if (data && data["data"]) {
			// 		let userAccounts = secureLocalStorage.getItem(currentUser?._id + "-T-Accounts");
			// 		if (userAccounts && userAccounts["accounts"] && userAccounts["accounts"].length > 0) {
			// 			await removeItemFromObjectArrayByMatchingProperties(userAccounts["accounts"], formData);
			// 			secureLocalStorage.setItem(currentUser?._id + "-T-Accounts", data["data"]);
			// 			dispatch({
			// 				type: GET_ALL_ACCOUNTS_OF_USER,
			// 				payload: data["data"]["accounts"],
			// 			});
			// 		} else {
			// 			alert("No accounts found in local database");
			// 		}
			// 		alert(data["message"]);
			// 	}
			// });
		} else if (currentUser?.loginType === "local") {
			const userData = await dexieDB.contacts
				.filter((item) => item?.userID === currentUser?._id)
				.first()
				.then((data) => {
					if (data) {
						return data;
					} else return null;
				});

			if (userData?.data) {
				let newUserContacts = await removeItemFromObjectArrayByMatchingProperties(userData?.data, formData);

				await dexieDB.contacts.update(userData.id, { data: newUserContacts }).then((updateCount) => {
					if (updateCount) notify("success", "Contact deleted");
					else notify("error", "Contact deletion failed");
				});

				dispatch({
					type: GET_ALL_CONTACTS_OF_USER,
					payload: newUserContacts,
				});
			}
		}
	} catch (error) {
		console.error(error);
	}
};
